<!-- ===================================== -->
<!-- FOOTER COMPONENT -->
<!-- ===================================== -->
<template name="Footer">
  <footer class="modern-footer">
    <div class="footer-top">
      <div class="container">
        <div class="row g-4">
          <!-- About Section -->
          <div class="col-md-4">
            <div class="footer-section">
              <img src="/images/logo.png" alt="Bee's Atelier" class="footer-logo mb-3" />
              <p class="footer-description">Handcrafted with love. Creating memorable moments through unique, personalized gifts and workshops.</p>
              <div class="social-links">
                <a href="#" class="social-link"><i class="fab fa-facebook-f"></i></a>
                <a href="#" class="social-link"><i class="fab fa-instagram"></i></a>
                <a href="#" class="social-link"><i class="fab fa-pinterest"></i></a>
                <a href="#" class="social-link"><i class="fab fa-youtube"></i></a>
              </div>
            </div>
          </div>

          <!-- Quick Links -->
          <div class="col-6 col-md-2">
            <div class="footer-section">
              <h5 class="footer-title">Quick Links</h5><hr>
              <ul class="footer-links">
                <li><a href="javascript:void(0)" @click="$router.push({ path: '/' })">Home</a></li>
                <li><a href="javascript:void(0)" @click="$router.push({ path: '/shop' })">Shop</a></li>
                <li><a href="javascript:void(0)" @click="$router.push({ path: '/workshop' })">Workshops</a></li>
                <li><a href="javascript:void(0)" @click="$router.push({ path: '/about' })">About Us</a></li>
                <li><a href="/blog">Blog</a></li>
              </ul>
            </div>
          </div>

          <!-- Customer Service -->
          <div class="col-6 col-md-3">
            <div class="footer-section">
              <h5 class="footer-title">Customer Service</h5><hr>
              <ul class="footer-links">
                <li><a href="javascript:void(0)" @click="$router.push({ path: '/contact' })">Contact Us</a></li>
                <li><a href="javascript:void(0)" @click="$router.push({ path: '/shipping-returns' })">Shipping & Returns</a></li>
                <li><a href="javascript:void(0)" @click="$router.push({ path: '/faq' })">FAQ</a></li>
                <li><a href="/track-order">Track Order</a></li>
              </ul>
            </div>
          </div>

          <!-- Contact Info -->
          <div class="col-md-3">
            <div class="footer-section">
              <h5 class="footer-title">Contact Us</h5><hr>
              <ul class="footer-contact">
                <li>
                  <i class="fas fa-map-marker-alt"></i>
                  <span>123 Craft Street, City, State</span>
                </li>
                <li>
                  <i class="fas fa-phone"></i>
                  <span>+1 (234) 567-8900</span>
                </li>
                <li>
                  <i class="fas fa-envelope"></i>
                  <span>hello@beesatelier.com</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer Bottom -->
    <div class="footer-bottom">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6 text-center text-md-start">
            <p class="mb-0">© {{ currentYear }} Bee's Atelier. All rights reserved.</p>
          </div>
          <div class="col-md-6">
            <ul class="footer-bottom-links">
              <li><a href="/privacy-policy">Privacy Policy</a></li>
              <li><a href="/terms">Terms & Conditions</a></li>
              <li><a href="/cookie-policy">Cookie Policy</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      currentYear: new Date().getFullYear()
    };
  }
};
</script>

<style scoped>
.modern-footer {
  background: #1a202c;
  color: #e2e8f0;
  font-family: 'Inter', sans-serif;
}

.footer-top {
  padding: 60px 0 40px;
}

.footer-logo {
  height: 50px;
  width: auto;
}

.footer-description {
  color: #a0aec0;
  line-height: 1.7;
  margin-bottom: 20px;
}

.social-links {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.social-link {
  width: 40px;
  height: 40px;
  background: rgba(255,255,255,0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-decoration: none;
  transition: all 0.3s;
}

.social-link:hover {
  background: rgb(118, 172, 175);
  transform: translateY(-3px);
  color: white;
}

.footer-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: white;
  position: relative;
  /*margin-bottom: 20px;
  padding-bottom: 10px;*/
}

/*.footer-title::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 40px;
  height: 2px;
  background: rgb(118, 172, 175);
}*/

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links li {
  margin-bottom: 10px;
}

.footer-links a {
  color: #a0aec0;
  text-decoration: none;
  transition: all 0.3s;
  display: inline-block;
}

.footer-links a:hover {
  color: rgb(118, 172, 175);
  transform: translateX(5px);
}

.footer-contact {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-contact li {
  display: flex;
  gap: 12px;
  margin-bottom: 15px;
  color: #a0aec0;
}

.footer-contact i {
  color: rgb(118, 172, 175);
  width: 18px;
  flex-shrink: 0;
  margin-top: 3px;
}

.footer-bottom {
  background: #0f1419;
  padding: 20px 0;
  border-top: 1px solid rgba(255,255,255,0.1);
}

.footer-bottom p {
  color: #a0aec0;
  font-size: 0.9rem;
}

.footer-bottom-links {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: flex-end;
  gap: 20px;
  flex-wrap: wrap;
}

.footer-bottom-links a {
  color: #a0aec0;
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.3s;
}

.footer-bottom-links a:hover {
  color: rgb(118, 172, 175);
}

@media (max-width: 768px) {
  .footer-top {
    padding: 40px 0 30px;
  }

  .footer-bottom-links {
    justify-content: center;
    margin-top: 15px;
  }
}
</style>